
import { Tbl_lega_stagioneEdit } from './tbl_lega_stagioneEdit';
import { Tbl_lega_stagioneList } from './tbl_lega_stagioneList';
import { Tbl_lega_stagioneShow } from './tbl_lega_stagioneShow';
import { Tbl_lega_stagioneCreate } from './tbl_lega_stagioneCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_lega_stagioneList,
    edit: Tbl_lega_stagioneEdit,
    show: Tbl_lega_stagioneShow,
    create: Tbl_lega_stagioneCreate,
    icon: MapIcon
};
            